// Utility untuk data wilayah Indonesia - 4 level cascading
// Semua data diambil dari ibnux/data-indonesia via GitHub Pages (static JSON)
// Provinsi dari file lokal, kabupaten/kecamatan/kelurahan dari GitHub Pages

export interface Provinsi {
  id: string;
  nama: string;
}

export interface KabupatenKota {
  id: string;
  nama: string;
}

export interface Kecamatan {
  id: string;
  nama: string;
}

export interface Kelurahan {
  id: string;
  nama: string;
}

const BASE_URL = 'https://ibnux.github.io/data-indonesia';

// In-memory caches
const kabupatenCache: Record<string, KabupatenKota[]> = {};
const kecamatanCache: Record<string, Kecamatan[]> = {};
const kelurahanCache: Record<string, Kelurahan[]> = {};

export async function getProvinsi(): Promise<Provinsi[]> {
  try {
    const res = await fetch('/data/provinsi.json');
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}

export async function getKabupatenByProvinsi(provinsiId: string): Promise<KabupatenKota[]> {
  if (!provinsiId) return [];
  if (kabupatenCache[provinsiId]) return kabupatenCache[provinsiId];
  try {
    const res = await fetch(`${BASE_URL}/kabupaten/${provinsiId}.json`);
    if (!res.ok) return [];
    const data: KabupatenKota[] = await res.json();
    kabupatenCache[provinsiId] = data;
    return data;
  } catch {
    return [];
  }
}

export async function getKecamatanByKabupaten(kabupatenId: string): Promise<Kecamatan[]> {
  if (!kabupatenId) return [];
  if (kecamatanCache[kabupatenId]) return kecamatanCache[kabupatenId];
  try {
    const res = await fetch(`${BASE_URL}/kecamatan/${kabupatenId}.json`);
    if (!res.ok) return [];
    const data: Kecamatan[] = await res.json();
    kecamatanCache[kabupatenId] = data;
    return data;
  } catch {
    return [];
  }
}

export async function getKelurahanByKecamatan(kecamatanId: string): Promise<Kelurahan[]> {
  if (!kecamatanId) return [];
  if (kelurahanCache[kecamatanId]) return kelurahanCache[kecamatanId];
  try {
    const res = await fetch(`${BASE_URL}/kelurahan/${kecamatanId}.json`);
    if (!res.ok) return [];
    const data: Kelurahan[] = await res.json();
    kelurahanCache[kecamatanId] = data;
    return data;
  } catch {
    return [];
  }
}
